import SecondarySidebar from './SecondarySidebar';
import { Crumb } from './PageBreadcrumb';

type NavigationItem = {
    name: string;
    href: string;
    current: boolean;
    icon: any;
};

interface PageWithSidebarProps {
    children: React.ReactNode;
    title?: string | React.ReactNode;
    subtitle?: string;
    actions?: React.ReactNode;
    navigation?: NavigationItem[];
    filters?: React.ReactNode;
    breadcrumbs?: Crumb[];
}

export default function PageWithSidebar({
    children,
    title,
    subtitle,
    actions,
    navigation = [],
    filters = null,
    breadcrumbs,
}: PageWithSidebarProps) {
    return (
        <SecondarySidebar
            title={title}
            subtitle={subtitle}
            actions={actions}
            navigation={navigation}
            filters={filters}
            breadcrumbs={breadcrumbs}
        >
            {children}
        </SecondarySidebar>
    );
}
